import React from "react";
import { PanchangDetails } from "../../Enum";
import { removeUnderscore } from "@/utils/helper";
import styles from "./WhiteCard.module.scss";

interface WhiteCardProps {
  data: PanchangDetails[];
}

const WhiteCard = ({ data }: WhiteCardProps) => {
  return (
    <div className={styles.whiteCard}>
      {data?.map(({ name, value, endTime }, index) => {
        return (
          <div className={styles.dataWrapper} key={index}>
            <div className={styles.subWrapper}>
              <p>{removeUnderscore(name)}</p>
            </div>
            <div className={styles.subWrapper}>
              <p>{value}</p>
              {endTime && <span>Ends at {endTime}</span>}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default WhiteCard;
